import script from "./ServicePriceLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicePriceLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./ServicePriceLogsPage.vue?vue&type=style&index=0&id=9076d182&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9076d182"]])

export default __exports__